/**
 * Contrato zod del health check de ANMAT (proxy via /api/anmat/status).
 *
 * El backend pasa por riga-traza-v2 que devuelve uno de 4 shapes (ver
 * anmat.service.js en el backend). Los unificamos en un schema laxo:
 *   - `ok` es el campo determinante.
 *   - `latency_ms` siempre llega.
 *   - El resto es opcional según el escenario.
 */

import { z } from 'zod';

export const AnmatStatusSchema = z.object({
  ok: z.boolean(),
  anmat_ws: z.string().optional(),
  latency_ms: z.number().optional(),
  gln_checked: z.string().optional(),
  razon_social: z.string().nullable().optional(),
  error: z.string().optional(),
});

export type AnmatStatus = z.infer<typeof AnmatStatusSchema>;
